'use strict';

import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { markAllTouched } from 'libraries/service/form/mark-touched.util';

export interface IOptionsCardForm {
    formGroup: FormGroup;
    labels?: {
        error: string;
        submit?: string;
    };
}

export enum Mode {
    BodyOnly = 'bodyOnly',
    AllParts = 'allParts',
}

/**
 * @description This component is the official wrapper to forms which needs card style
 */
@Component({
    selector: 'card-form',
    template: `
        <section class="card card-margin-outside">
            <form novalidate (ngSubmit)="submit()"
                [formGroup]="options.formGroup">
                <!-- header -->
                <header *ngIf="mode !== 'bodyOnly'"
                    class="header"
                    [class.em]="isEmphasis">
                    <ng-content select=".card-header-content"></ng-content>
                    <div class="ctn ctn-right">
                        <!-- You can add some btn here -->
                        <ng-content select=".btn-right"></ng-content>
                        <btnForm *ngIf="options.labels?.submit" class="submit-btn e2e-btn-search-booking"
                                 [disabled]="disabled"
                            formType="submit"
                            styleType="actionPrincipal">
                            {{ options.labels.submit }}
                        </btnForm>
                    </div>
                </header>
                <ng-content select=".card-sub-header-content"></ng-content>
                <ng-content select="notification"></ng-content>

                <!-- body -->
                <div class="body e2e-input">
                    <notification *ngIf="submitted && options.formGroup.invalid"
                        type="error">
                        {{ options.labels.error }}
                    </notification>
                    <div>
                        <ng-content select=".card-body-content" class="e2e-input-xxx"></ng-content>
                    </div>
                </div>

                <!-- footer -->
                <footer *ngIf="mode !== 'bodyOnly'"
                    class="footer"
                    #footerContainer>
                    <ng-content select=".card-footer-content"></ng-content>
                </footer>
            </form>
        </section>
    `,
    styles: [`
        .header {
            display: flex;
        }

        notification {
            margin-bottom: 15px;
        }
    `]
})
export class CardFormComponent {

    @Input()
    public isEmphasis: boolean = false;
    @Input()
    public disabled: boolean = false;

    @Input()
    public options: IOptionsCardForm;

    @Input()
    public mode: Mode = Mode.AllParts;

    @Output()
    public readonly onSubmit: EventEmitter<null> = new EventEmitter();

    @Output()
    public readonly isError: EventEmitter<boolean> = new EventEmitter();

    public submitted: boolean = false;

    public reset(): void {
        this.submitted = false;
        this.options.formGroup.reset();
    }

    public submit(): void {
        markAllTouched(this.options.formGroup);
        this.options = { ...this.options };
        this.submitted = true;
        if (this.options.formGroup.valid) {
            this.onSubmit.emit();
        }
    }

}
